function initExhibitionGalleryLightbox() {
  if (!document.body.classList.contains('single-exhibition')) {
    return;
  }

  var galleryLinks = document.querySelectorAll('.single-exhibition .tour-content .gallery .gallery-item a[href]');
  if (!galleryLinks.length) {
    return;
  }

  if (document.getElementById('nets-gallery-lightbox')) {
    return;
  }

  var modal = document.createElement('div');
  modal.id = 'nets-gallery-lightbox';
  modal.className = 'nets-gallery-lightbox';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML =
    '<div class="nets-gallery-lightbox__backdrop" data-close="1"></div>' +
    '<div class="nets-gallery-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Image preview">' +
      '<button type="button" class="nets-gallery-lightbox__close" aria-label="Close image preview">Close</button>' +
      '<img class="nets-gallery-lightbox__image" alt="" />' +
      '<p class="nets-gallery-lightbox__caption is-hidden"></p>' +
    '</div>';

  document.body.appendChild(modal);

  var modalImage = modal.querySelector('.nets-gallery-lightbox__image');
  var modalCaption = modal.querySelector('.nets-gallery-lightbox__caption');
  var closeButton = modal.querySelector('.nets-gallery-lightbox__close');
  var lastFocusedElement = null;

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nets-lightbox-open');
    modalImage.removeAttribute('src');
    modalImage.setAttribute('alt', '');
    modalCaption.textContent = '';
    modalCaption.classList.add('is-hidden');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function openModal(src, altText, captionText, trigger) {
    modalImage.setAttribute('src', src);
    modalImage.setAttribute('alt', altText || '');
    if (captionText) {
      modalCaption.textContent = captionText;
      modalCaption.classList.remove('is-hidden');
    } else {
      modalCaption.textContent = '';
      modalCaption.classList.add('is-hidden');
    }
    lastFocusedElement = trigger || document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nets-lightbox-open');
    closeButton.focus();
  }

  galleryLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      var previewImg = link.querySelector('img');
      var fullSrc = link.getAttribute('href');
      var altText = previewImg ? previewImg.getAttribute('alt') : '';
      var galleryItem = link.closest('.gallery-item');
      var captionEl = galleryItem ? galleryItem.querySelector('.gallery-caption') : null;
      var captionText = captionEl ? captionEl.textContent.trim() : '';

      openModal(fullSrc, altText, captionText, link);
    });
  });

  modal.addEventListener('click', function(e) {
    var target = e.target;
    if (target && (target.getAttribute('data-close') === '1' || target === closeButton)) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (!modal.classList.contains('is-open')) {
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
    }
  });
}

  function initExhibitions($) {
    initExhibitionGalleryLightbox();

    // if not on exhibitions landing page, exit
    if ($('.exhibitions-landing').length == 0) {
      return;
    }

  var qsRegex;
  var selectedSizes = [];
  var selectedMediums = [];

  function syncFiltersToUrl() {
    var $form = $('.exhibitions-landing .exhibitions-filter__form');
    if ($form.length === 0) {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var filterKeys = [
      'keyword',
      'exhibition_size',
      'medium',
      'date_from_month',
      'date_from_year',
      'date_to_month',
      'date_to_year',
      'fav_only',
      'sort_by',
      'paged',
      'load_more'
    ];

    filterKeys.forEach(function(key) {
      params.delete(key);
    });

    var keywordValue = $form.find('input[name="keyword"]').val();
    if (keywordValue) {
      params.set('keyword', keywordValue);
    }

    if (selectedSizes.length > 0) {
      params.set('exhibition_size', selectedSizes.join(','));
    }

    if (selectedMediums.length > 0) {
      params.set('medium', selectedMediums.join(','));
    }

    function formatMonthAbbrev(monthValue) {
      if (!monthValue) {
        return '';
      }
      var monthIndex = parseInt(monthValue, 10);
      if (isNaN(monthIndex)) {
        return '';
      }
      var labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return labels[monthIndex - 1] || '';
    }

    var dateFromMonth = formatMonthAbbrev($form.find('select[name="date_from_month"]').val());
    var dateFromYear = $form.find('select[name="date_from_year"]').val();
    var dateToMonth = formatMonthAbbrev($form.find('select[name="date_to_month"]').val());
    var dateToYear = $form.find('select[name="date_to_year"]').val();
    var sortBy = $form.find('select[name="sort_by"]').val();
    var favOnly = $form.find('input[name="fav_only"]').is(':checked');

    if (dateFromMonth) {
      params.set('date_from_month', dateFromMonth);
    }
    if (dateFromYear) {
      params.set('date_from_year', dateFromYear);
    }
    if (dateToMonth) {
      params.set('date_to_month', dateToMonth);
    }
    if (dateToYear) {
      params.set('date_to_year', dateToYear);
    }
    if (sortBy) {
      params.set('sort_by', sortBy);
    }
    if (favOnly) {
      params.set('fav_only', '1');
    }

    var newUrl = window.location.pathname;
    var queryString = params.toString();
    if (queryString) {
      newUrl += '?' + queryString;
    }
    if (window.location.hash) {
      newUrl += window.location.hash;
    }

    window.history.replaceState({}, '', newUrl);
  }

  var exhibitionSessionTimer = null;
  function queueExhibitionSessionUpdate(idsOverride) {
    if (typeof netsExhibitions === 'undefined' || !netsExhibitions.ajaxUrl) {
      return;
    }
    if (exhibitionSessionTimer) {
      clearTimeout(exhibitionSessionTimer);
    }
    exhibitionSessionTimer = setTimeout(function() {
      var ids = Array.isArray(idsOverride) && idsOverride.length ? idsOverride : getFilteredExhibitionIds();
      $.post(netsExhibitions.ajaxUrl, {
        action: 'nets_set_exhibition_results',
        nonce: netsExhibitions.nonce,
        ids: ids,
        source_url: window.location.href
      });
    }, 200);
  }

  function getFilteredExhibitionIds() {
    if (!iso || !iso.filteredItems) {
      return [];
    }
    return iso.filteredItems.map(function(item) {
      var $item = $(item.element);
      var dataId = parseInt($item.data('exhibition-id'), 10);
      if (dataId) {
        return dataId;
      }
      var idAttr = $item.attr('id') || '';
      var match = idAttr.match(/post-(\d+)/);
      return match ? parseInt(match[1], 10) : null;
    }).filter(function(id) {
      return !!id;
    });
  }

  // use value of search field to filter
  var $quicksearch = $('.exhibitions-landing .exhibitions-filter__form input').keyup( debounce( function() {

     const keyword_value = $(this).val();
      // if (keyword_value.length < 3 && keyword_value.length > 0) {
      //   return;
      // }

        qsRegex = new RegExp( keyword_value, 'gi' );
        console.log('qs changed');
    $grid.isotope();
    loadMore(initShow);
      syncFiltersToUrl();
  }, 200 ) );

  $(".exhibitions-landing .exhibitions-filter__form input[name=\"keyword\"]").on("keydown", function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });

 
  $(".exhibitions-landing .exhibitions-filter__form input[type=\"checkbox\"]").on("change", function() {
      $grid.find(".hidden").removeClass("hidden");
      loadMore(initShow);
      syncFiltersToUrl();
      renderSelectedFilterChips();
  });

  function initSelectOptionLabels($select) {
    $select.find('option').each(function() {
      var $option = $(this);
      if ($option.data('label') === undefined) {
        $option.data('label', $option.text());
      }
    });
  }

  function initMobileSelectDropdowns() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }

    var $form = $('.exhibitions-landing .exhibitions-filter__form');
    if ($form.length === 0) {
      return;
    }

    $form.addClass('has-nets-select');

    $form.find('select').each(function() {
      var $select = $(this);
      if ($select.data('mobileDropdownInit')) {
        return;
      }
      $select.data('mobileDropdownInit', true);

      var selectId = $select.attr('id') || '';
      var $wrapper = $('<div class="nets-select" data-select-id="' + selectId + '"></div>');
      var $trigger = $('<button type="button" class="nets-select__trigger" aria-haspopup="listbox" aria-expanded="false"></button>');
      var $list = $('<div class="nets-select__list" role="listbox"></div>');

      $wrapper.append($trigger, $list);
      $select.after($wrapper);

      function updateTrigger() {
        var label = $select.find('option:selected').text() || $select.find('option').first().text();
        $trigger.text(label);
      }

      function renderOptions() {
        $list.empty();
        $select.find('option').each(function() {
          var $option = $(this);
          var value = $option.attr('value') || '';
          var text = $option.text();
          var $item = $('<button type="button" class="nets-select__option" role="option"></button>');
          $item.text(text);
          $item.attr('data-value', value);
          if ($option.is(':selected')) {
            $item.addClass('is-selected');
          }
          $list.append($item);
        });
        updateTrigger();
      }

      renderOptions();

      $trigger.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = $wrapper.hasClass('is-open');
        $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
        $wrapper.toggleClass('is-open', !isOpen);
        $trigger.attr('aria-expanded', String(!isOpen));
      });

      $list.on('click', '.nets-select__option', function() {
        var value = $(this).attr('data-value');
        $select.val(value);
        $select.trigger('change');
        renderOptions();
        $wrapper.removeClass('is-open');
        $trigger.attr('aria-expanded', 'false');
      });

      $select.on('change.mobileSelect', function() {
        renderOptions();
      });
    });

    $(document).off('click.netsSelect').on('click.netsSelect', function() {
      $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
    });
  }

  function initMobileFilterToggle() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }

    var $form = $('.exhibitions-landing .exhibitions-filter__form');
    if ($form.length === 0) {
      return;
    }

    var $toggle = $form.find('.exhibitions-filter__toggle');
    if ($toggle.length === 0) {
      return;
    }

    if ($toggle.data('initToggle')) {
      return;
    }

    $toggle.data('initToggle', true);

    var $fields = $form.find('.exhibitions-filter__fields');

    function setMobileFilterState(isOpen) {
      $form.toggleClass('is-filters-open', isOpen);
      $toggle.attr('aria-expanded', String(isOpen));

      if ($fields.length) {
        $fields.prop('hidden', !isOpen);
      }

      if (!isOpen) {
        $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
      }
    }

    setMobileFilterState($form.hasClass('is-filters-open'));

    $toggle.off('click.exhibitionsFilters').on('click.exhibitionsFilters', function() {
      setMobileFilterState(!$form.hasClass('is-filters-open'));
    });
  }

  function renderSelectedFilterChips() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }

    var $form = $('.exhibitions-landing .exhibitions-filter__form');
    if ($form.length === 0) {
      return;
    }

    var $container = $form.find('[data-selected-filters]');
    if ($container.length === 0) {
      return;
    }

    $container.empty();

    function addChip(label, type, value, ariaLabel) {
      var $chip = $('<span class="exhibitions-filter__chip"></span>');
      var $text = $('<span class="exhibitions-filter__chip-label"></span>').text(label);
      var $remove = $('<button type="button" class="exhibitions-filter__chip-remove"></button>');
      $remove.attr('data-type', type);
      if (value) {
        $remove.attr('data-value', value);
      }
      $remove.attr('aria-label', ariaLabel || 'Remove filter');
      $chip.append($text, $remove);
      $container.append($chip);
    }

    selectedSizes.forEach(function(value) {
      var $option = $sizeSelect.find('option[value="' + value + '"]');
      var label = $option.data('label') || $option.text();
      label = label.replace(/^✓\s*/, '');
      addChip(label, 'size', value, 'Remove size');
    });

    selectedMediums.forEach(function(value) {
      var $option = $mediumSelect.find('option[value="' + value + '"]');
      var label = $option.data('label') || $option.text();
      label = label.replace(/^✓\s*/, '');
      addChip(label, 'medium', value, 'Remove medium');
    });

    function formatMonthAbbrev(monthValue) {
      if (!monthValue) {
        return '';
      }
      var monthIndex = parseInt(monthValue, 10);
      if (isNaN(monthIndex)) {
        return '';
      }
      var labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return labels[monthIndex - 1] || '';
    }

    var dateFromMonth = formatMonthAbbrev($form.find('select[name="date_from_month"]').val());
    var dateFromYear = $form.find('select[name="date_from_year"]').val();
    var dateToMonth = formatMonthAbbrev($form.find('select[name="date_to_month"]').val());
    var dateToYear = $form.find('select[name="date_to_year"]').val();

    if (dateFromMonth || dateFromYear) {
      var fromLabel = 'From ' + (dateFromMonth || '') + (dateFromYear ? ' ' + dateFromYear : '');
      addChip(fromLabel.trim(), 'date-from', '', 'Remove date from');
    }

    if (dateToMonth || dateToYear) {
      var toLabel = 'To ' + (dateToMonth || '') + (dateToYear ? ' ' + dateToYear : '');
      addChip(toLabel.trim(), 'date-to', '', 'Remove date to');
    }

    var favOnly = $form.find('input[name="fav_only"]').is(':checked');
    if (favOnly) {
      addChip('Favourites only', 'fav', '', 'Remove favourites only');
    }

    if ($container.children().length) {
      $container.show();
    } else {
      $container.hide();
    }
  }

  function collapseMobileFilters() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }

    var $form = $('.exhibitions-landing .exhibitions-filter__form');
    if ($form.length === 0) {
      return;
    }

    var $toggle = $form.find('.exhibitions-filter__toggle');
    var fields = $form.find('.exhibitions-filter__fields').get(0);

    $form.removeClass('is-filters-open');
    if ($toggle.length) {
      $toggle.attr('aria-expanded', 'false');
    }
    if (fields) {
      fields.hidden = true;
    }
    $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
  }

  function getFilterLabel($select) {
    var $firstOption = $select.find('option').first();
    var baseLabel = $firstOption.data('label') || $firstOption.text();
    if (baseLabel.toLowerCase().startsWith('all ')) {
      return baseLabel.slice(4);
    }
    return baseLabel;
  }

  function pluralizeFilterLabel(label, count) {
    if (count === 1) {
      return label.endsWith('s') ? label.slice(0, -1) : label;
    }
    return label;
  }

  function updateFirstOptionLabel($select, selectedValues) {
    var $firstOption = $select.find('option').first();
    var baseLabel = $firstOption.data('label') || $firstOption.text();
    if (selectedValues.length === 0) {
      $firstOption.text(baseLabel);
      return;
    }
    if (selectedValues.length === 1) {
      var selectedValue = selectedValues[0];
      var $selectedOption = $select.find('option[value="' + selectedValue + '"]');
      var selectedLabel = $selectedOption.data('label') || $selectedOption.text();
      $firstOption.text(selectedLabel.replace(/^✓\s*/, ''));
      return;
    }
    var filterLabel = getFilterLabel($select);
    var labelText = pluralizeFilterLabel(filterLabel, selectedValues.length);
    console.log('filterLabel: ' + filterLabel);
    console.log('selectedValues.length: ' + selectedValues.length);
    console.log('labelText: ' + labelText);
    if ((filterLabel == 'Sizes') && (selectedValues.length === 4)) {
      $firstOption.text('All' + ' ' + labelText);
    } else {
      if (labelText == 'Mediums') {
        labelText = 'Media';
      }
      $firstOption.text(selectedValues.length + ' ' + labelText + ' chosen');
    }
  }

  function setOptionCheckmarks($select, selectedValues) {
    $select.find('option').each(function() {
      var $option = $(this);
      var baseLabel = $option.data('label') || $option.text();
      var value = $option.attr('value');
      if (!value) {
        $option.text(baseLabel);
        return;
      }
      if (selectedValues.includes(value)) {
        $option.text('✓ ' + baseLabel);
      } else {
        $option.text(baseLabel);
      }
    });
    updateFirstOptionLabel($select, selectedValues);
  }

  function applyMultiFilters() {
    $grid.find(".hidden").removeClass("hidden");
    loadMore(initShow);
  }

  function toggleSelectedValue(list, value) {
    var index = list.indexOf(value);
    if (index === -1) {
      list.push(value);
    } else {
      list.splice(index, 1);
    }
  }

  var $sizeSelect = $(".exhibitions-landing .exhibitions-filter__form select[name=\"exhibition_size\"]");
  var $mediumSelect = $(".exhibitions-landing .exhibitions-filter__form select[name=\"medium\"]");

  initSelectOptionLabels($sizeSelect);
  initSelectOptionLabels($mediumSelect);

  if ($sizeSelect.val()) {
    selectedSizes = [$sizeSelect.val()];
  }
  if ($mediumSelect.val()) {
    selectedMediums = [$mediumSelect.val()];
  }

  setOptionCheckmarks($sizeSelect, selectedSizes);
  setOptionCheckmarks($mediumSelect, selectedMediums);
  renderSelectedFilterChips();

  initMobileSelectDropdowns();
  initMobileFilterToggle();

  $sizeSelect.on('change', function() {
    var value = $(this).val();
    if (value) {
      toggleSelectedValue(selectedSizes, value);
    } else {
      selectedSizes = [];
    }
    setOptionCheckmarks($sizeSelect, selectedSizes);
    renderSelectedFilterChips();
    $(this).val('');
    applyMultiFilters();
    syncFiltersToUrl();
  });

  $mediumSelect.on('change', function() {
    var value = $(this).val();
    if (value) {
      toggleSelectedValue(selectedMediums, value);
    } else {
      selectedMediums = [];
    }
    setOptionCheckmarks($mediumSelect, selectedMediums);
    renderSelectedFilterChips();
    $(this).val('');
    applyMultiFilters();
    syncFiltersToUrl();
  });

  function clearAllFilters() {
    var $form = $('.exhibitions-landing .exhibitions-filter__form');
    if ($form.length === 0) {
      return;
    }

    qsRegex = null;
    selectedSizes = [];
    selectedMediums = [];

    $form[0].reset();
    $form.find('input[name="keyword"]').val('');
    $form.find('input[type="checkbox"]').prop('checked', false);
    $form.find('select').each(function() {
      this.selectedIndex = 0;
    });

    $sizeSelect.val('');
    $mediumSelect.val('');
    setOptionCheckmarks($sizeSelect, selectedSizes);
    setOptionCheckmarks($mediumSelect, selectedMediums);
    renderSelectedFilterChips();

    setSortFromSelection($('#sort_by').val());
    $form.find('select').trigger('change.mobileSelect');

    $grid.find('.hidden').removeClass('hidden');
    $grid.isotope();
    loadMore(initShow);
    syncFiltersToUrl();
    collapseMobileFilters();
  }

  $(document).on('click', '[data-clear-filters]', function(e) {
    e.preventDefault();
    clearAllFilters();
  });

  $(document).on('click', '#exhibitions-show-results', function(e) {
    e.preventDefault();
    collapseMobileFilters();
  });

  $(document).on('click', '.exhibitions-filter__chip-remove', function(e) {
    e.preventDefault();

    var $form = $('.exhibitions-landing .exhibitions-filter__form');
    var type = $(this).attr('data-type') || '';
    var value = $(this).attr('data-value') || '';

    if (type === 'size') {
      selectedSizes = selectedSizes.filter(function(item) {
        return item !== value;
      });
      setOptionCheckmarks($sizeSelect, selectedSizes);
      $sizeSelect.val('');
      $sizeSelect.trigger('change.mobileSelect');
    }

    if (type === 'medium') {
      selectedMediums = selectedMediums.filter(function(item) {
        return item !== value;
      });
      setOptionCheckmarks($mediumSelect, selectedMediums);
      $mediumSelect.val('');
      $mediumSelect.trigger('change.mobileSelect');
    }

    if (type === 'date-from') {
      $form.find('select[name="date_from_month"]').val('');
      $form.find('select[name="date_from_year"]').val('');
      $form.find('select[name="date_from_month"]').trigger('change.mobileSelect');
      $form.find('select[name="date_from_year"]').trigger('change.mobileSelect');
    }

    if (type === 'date-to') {
      $form.find('select[name="date_to_month"]').val('');
      $form.find('select[name="date_to_year"]').val('');
      $form.find('select[name="date_to_month"]').trigger('change.mobileSelect');
      $form.find('select[name="date_to_year"]').trigger('change.mobileSelect');
    }

    if (type === 'fav') {
      $form.find('input[name="fav_only"]').prop('checked', false);
    }

    renderSelectedFilterChips();
    applyMultiFilters();
    syncFiltersToUrl();
  });


 $(".exhibitions-landing .exhibitions-filter__form select").on("change", function() {
      // On filter change, reset load more button
      console.log('filter changed');
      const item_changed = ($(this).attr("name"));
      if (item_changed == 'keyword') {
        // only reload if more then 2 chartacters entered
      }
      console.log('filkkkter changed');

      setSortFromSelection($('#sort_by').val());

      $grid.find(".hidden").removeClass("hidden");
      $grid.isotope({ sortBy: sortValue, sortAscending: sortAscending });
      loadMore(initShow);
      syncFiltersToUrl();
      renderSelectedFilterChips();
      // $grid.isotope('reloadItems').isotope({ filter: '*' });

    });

  // debounce so filtering doesn't happen every millisecond
  function debounce( fn, threshold ) {
    var timeout;
    threshold = threshold || 100;
    return function debounced() {
      clearTimeout( timeout );
      var args = arguments;
      var _this = this;
      function delayed() {
        fn.apply( _this, args );
      }
      timeout = setTimeout( delayed, threshold );
    };
  }

  var MAX_PRICE_CENTS = 9999999999;
  var sortValue = 'date';
  var sortAscending = false;

  function getDailySeed() {
    var gridSeed = $('.exhibitions-grid__list').attr('data-daily-random-seed');
    if (gridSeed) {
      return gridSeed;
    }

    var now = new Date();
    var year = now.getFullYear();
    var month = String(now.getMonth() + 1).padStart(2, '0');
    var day = String(now.getDate()).padStart(2, '0');
    return year + month + day;
  }

  function hashString(value) {
    var hash = 2166136261;
    for (var i = 0; i < value.length; i++) {
      hash ^= value.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return hash >>> 0;
  }

  function getDailyRandomKey($elem) {
    var dataId = $elem.attr('data-exhibition-id') || '';
    if (!dataId) {
      var idAttr = $elem.attr('id') || '';
      var match = idAttr.match(/post-(\d+)/);
      if (match) {
        dataId = match[1];
      }
    }
    var seed = getDailySeed();
    return hashString(seed + '-' + String(dataId || $elem.index()));
  }

  function setSortFromSelection(value) {
    var selected = value || 'default';
    sortValue = 'date';
    sortAscending = false;
    switch (selected) {
      case 'default':
        sortValue = 'random';
        sortAscending = true;
        break;
      case 'date_desc':
        sortValue = 'date';
        sortAscending = false;
        break;
      case 'date_asc':
        sortValue = 'date';
        sortAscending = true;
        break;
      case 'title_desc':
        sortValue = 'name';
        sortAscending = false;
        break;
      case 'title_asc':
        sortValue = 'name';
        sortAscending = true;
        break;
      case 'price_low':
        sortValue = 'price_low';
        sortAscending = true;
        break;
      case 'price_high':
        sortValue = 'price_high';
        sortAscending = true;
        break;
    }
  }

    function buildPriceSortKey($elem, isHighToLow) {
      var priceType = $elem.attr('data-price-type') || '';
      var priceValue = parseFloat($elem.attr('data-price-value')) || 0;
      var priceCents = Math.round(priceValue * 100);
      var priceFreight = $elem.attr('data-price-freight') || '';
      var name = ($elem.attr('data-name') || '').toLowerCase();

      var typeRank = priceType === 'fixed' ? 0 : 1;
      var priceRankCents = isHighToLow ? (MAX_PRICE_CENTS - priceCents) : priceCents;
      var freightRank = 2;

      if (isHighToLow) {
        if (priceFreight === 'ex_freight') freightRank = 0;
        if (priceFreight === 'inc_freight') freightRank = 1;
      } else {
        if (priceFreight === 'inc_freight') freightRank = 0;
        if (priceFreight === 'ex_freight') freightRank = 1;
      }

      var priceRankPadded = String(priceRankCents).padStart(10, '0');

      return typeRank + '|' + priceRankPadded + '|' + freightRank + '|' + name;
    }

    // init Isotope
    var $grid = $('.exhibitions-grid__list').isotope({
      itemSelector: 'article',
      layoutMode: 'masonry',
      masonry: {
        gutter: 40
      },      
      filter: function() {
        var $this = $(this);
        if ($this.hasClass('hidden')) {
          return false;
        }
        var favouritesOnly = $('.exhibitions-landing .exhibitions-filter__form input[name="fav_only"]').is(':checked');
        if (favouritesOnly && !$this.hasClass('is-favourite')) {
          return false;
        }
        var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
        var selectFilters = $('.exhibitions-landing .exhibitions-filter__form select');
        var buttonFilter = null;
        
        selectFilters.each(function() {
          var $select = $(this);
          var selectName = $select.attr('name');
          if (selectName === 'exhibition_size' || selectName === 'medium') {
            return;
          }
          var filterValue = $select.val();
          var filterprefix = $select.data('filterprefix') || false;
          if (filterValue && filterprefix) {
            filterValue = filterprefix + filterValue;
            if ( !$this.is( '.' + filterValue ) ) {
              searchResult = false;
            }
          }
          // if (filterValue && filterValue !== '') {
          //   console.log('=======filter=========');
          //   console.log($(this).attr('name'));
          //   console.log(filterValue);
          // }
        }
        );
      
        if (selectedSizes.length > 0) {
          var matchesSize = false;
          selectedSizes.forEach(function(value) {
            if ($this.is('.filter-size-' + value)) {
              matchesSize = true;
            }
          });
          if (!matchesSize) {
            searchResult = false;
          }
        }

        if (selectedMediums.length > 0) {
          var matchesMedium = false;
          selectedMediums.forEach(function(value) {
            if ($this.is('.filter-media-' + value)) {
              matchesMedium = true;
            }
          });
          if (!matchesMedium) {
            searchResult = false;
          }
        }

        // Date overlap: include this exhibition if any part of its
        // [item_datefrom, item_dateto] range overlaps the user's selected
        // [filter_datefrom, filter_dateto] range. Standard interval-overlap:
        //   item_from <= filter_to  AND  item_to >= filter_from
        // Each side of the test is dropped if the user didn't supply that
        // bound, so a single-ended search behaves as "ends on/after from"
        // or "starts on/before to". Mirrors the server query in
        // page-templates/exhibitions-landing.php.
        var item_datefrom = $(this).attr('data-datefrom');
        var item_dateto   = $(this).attr('data-dateto');

        var filter_datefrom_month = $('.exhibitions-landing .exhibitions-filter__form select[name="date_from_month"]').val();
        var filter_datefrom_year  = $('.exhibitions-landing .exhibitions-filter__form select[name="date_from_year"]').val();

        if (filter_datefrom_year) {
          var fdm = filter_datefrom_month || '01';
          // First day of the chosen month, Ymd.
          var filter_datefrom = filter_datefrom_year + ('0' + fdm).slice(-2) + '01';
          if (item_dateto && item_dateto < filter_datefrom) {
            searchResult = false;
          }
        }

        var filter_dateto_month = $('.exhibitions-landing .exhibitions-filter__form select[name="date_to_month"]').val();
        var filter_dateto_year  = $('.exhibitions-landing .exhibitions-filter__form select[name="date_to_year"]').val();

        if (filter_dateto_year) {
          var tdm = filter_dateto_month || '12';
          // Last day of the chosen month, Ymd. Date(year, monthIndex, 0)
          // returns the last day of (monthIndex - 1), so passing the chosen
          // month directly gives us its last day.
          var lastDay = new Date(parseInt(filter_dateto_year, 10), parseInt(tdm, 10), 0).getDate();
          var filter_dateto = filter_dateto_year + ('0' + tdm).slice(-2) + ('0' + lastDay).slice(-2);
          if (item_datefrom && item_datefrom > filter_dateto) {
            searchResult = false;
          }
        }


        // var filter_dateto = $('.exhibitions-landing .exhibitions-filter__form select[name="date_to"]').val();
        // console.log('filter_dateto: ' + filter_dateto);


        var buttonResult = true;//buttonFilter ? $this.is( buttonFilter ) : true;
        return searchResult && buttonResult;



      }, 
      getSortData: {
        name: '[data-name]',
        date: '[data-datefrom]',
        random: function(itemElem) {
          return getDailyRandomKey($(itemElem));
        },
        price_low: function(itemElem) {
          return buildPriceSortKey($(itemElem), false);
        },
        price_high: function(itemElem) {
          return buildPriceSortKey($(itemElem), true);
        }
      }
    });

      
  
    setSortFromSelection($('#sort_by').val());
    $grid.isotope({ sortBy: sortValue, sortAscending: sortAscending });

    var iso = $grid.data('isotope'); // get Isotope instance
  
    function loadMore(toShow) {
    $grid.find(".hidden").removeClass("hidden");
    $grid.isotope('arrange');

    var filteredIds = getFilteredExhibitionIds();
    queueExhibitionSessionUpdate(filteredIds);

    var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
      return item.element;
    });
    $(hiddenElems).addClass('hidden');
    $grid.isotope('arrange');

    //when no more to load, hide show more button
    if (hiddenElems.length == 0) {
      jQuery(".load-more").hide();
    } else {
      jQuery(".load-more").show();
    };

    updateResultsCount();
  }

  var initShow = 12;
  var counter = initShow; //counter for load more button

  loadMore(initShow); //execute function onload


    function updateResultsCount() {
      var filteredElems = $grid.isotope('getFilteredItemElements');
      var visibleCount = $(filteredElems).not('.hidden').length;
      var totalCount = filteredElems.length;
      var found_posts = parseInt($(".exhibitions-landing .load-more a").attr("data-foundposts"), 10) || 0;
      var resultsCountText = visibleCount === 0
        ? '0 of ' + (new Intl.NumberFormat().format(found_posts)) + ' exhibitions'
        : visibleCount + ' matching exhibition' + (visibleCount === 1 ? '' : 's');
      document.getElementById('results-count').innerText = resultsCountText;

      var showButton = document.getElementById('exhibitions-show-results');
      if (showButton) {
        showButton.textContent = 'Show (' + totalCount + ')';
      }
    }
    updateResultsCount();


 //when load more button clicked
  $(".exhibitions-landing .load-more a").click(function(e) {
    e.preventDefault();
    if ($('#filters').data('clicked')) {
      //when filter button clicked, set initial value for counter
      counter = initShow;
      $('#filters').data('clicked', false);
    } else {
      counter = counter;
    };

    counter = counter + initShow;

    loadMore(counter);
  });
    
    
  }

  export default initExhibitions;
